<div class="container-fluid">
    <div class="header-container">
      <div class="page-header"><span class="fa fa-users"></span>{{ 'bikeshop.menu.users' | translate }}</div>
      <div class="loading" *ngIf="loading">
        <div class="loader"></div>
      </div>
    </div>
    <div class="content">
        <div class="row">          
                <div pTooltip="{{ 'bikeshop.users.create_a_new_user' | translate }}" tooltipPosition="left" class="fa fa-user-plus font-button pull-right" style="margin-left: auto!important;margin-right: 16px!important;" (click)="addUser()"></div>
        </div>
        <div class="margin-top-16">
            <p-table #usersTable [columns]="columns" [value]="users">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" style="vertical-align: middle;" *ngIf="col.type !== 'action'"></p-sortIcon>
                        </th>
                        <th style="width: 60px;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user let-columns="columns">
                    <tr [pSelectableRow]="user">
                        <td *ngFor="let col of columns">
                          <div *ngIf="col.type!=='action'">
                              {{
                              col.type==='date' ? 
                                (user[col.field] | date : "dd MMM yyyy") 
                              : col.type==='technician' ?
                                (user[col.field] > 0 ? ('bikeshop.users.technician_view' | translate) : user.UserID===0 ? ('bikeshop.users.not_linked_to_a_user' | translate) : ('bikeshop.users.admin_view' | translate))
                              : col.type==='technician_status' ?
                                (user.IsActive || (user.Technician && user.Technician.IsActive) ? ('bikeshop.users.active' | translate) : 
                                (!user.Email && !user.IsActive ? ('bikeshop.users.inactive' | translate) : ""))
                              : user[col.field]
                            }}
                          </div>
                        </td>
                        <td style="text-align:left;">
                          <div pTooltip="{{ 'bikeshop.users.edit_user' | translate }}" tooltipPosition="left" *ngIf="user.Email" class="fa fa-pencil font-button" (click)="editUser(user)"></div>
                          <div pTooltip="{{ 'bikeshop.users.link_technician' | translate }}" tooltipPosition="left" *ngIf="!user.Email" class="fa fa-unlink font-button" (click)="editUser(user)"></div>
                          <!--<div pTooltip="Edit technicians events" tooltipPosition="top" *ngIf="user.UserID===0 || user.TechnicianID>0" class="fa fa-calendar-o font-button" (click)="linkTechnician(user)"></div>
                          <div pTooltip="Edit technicians working hours" tooltipPosition="top" *ngIf="user.UserID===0 || user.TechnicianID>0" class="fa fa-clock-o font-button" (click)="linkTechnician(user)"></div>-->
                        </td>
                    </tr>                  
                </ng-template>
            </p-table>
        </div>
    </div>
  